import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import { parseDate } from '../utils/datetime'

function TimestampWithUTCTooltip({ children, placement = "bottom", delayShow = 100, delayHide = 250 }) {
    let date = children
    if (typeof date == "undefined" || date == null) {
        return ''
    }
    if (typeof date == "undefined" || date == null) {
        return ''
    } else if (typeof (date) == typeof ("string")) {
        if (date == "") {
            return ""
        }
        date = parseDate(date)
    } else if (false == date instanceof Date) {
        console.error(children)
        throw Error("Received the following input parameter in TimestampWithUTCTooltip constructor:\n".concat(date))
    }

    const renderTooltip = function (props) {
        return (
            <Tooltip {...props}><a>{date.toISOString()} UTC</a></Tooltip>
        )
    }

    return (
        <OverlayTrigger
            placement={placement}
            delay={{ show: delayShow, hide: delayHide }}
            overlay={renderTooltip}
        ><span>{date.toLocaleString()}</span></OverlayTrigger>
    )
}

export default TimestampWithUTCTooltip